export interface AsmrResource {
  id: string;
  name: string;
  url: string;
  description: string;
  category: string;
  tags: string[];
  rating: number;
  featured: boolean;
  imageUrl: string;
}

export const asmrResources: AsmrResource[] = [
  {
    id: 'r1',
    name: 'ASMR耳音坊',
    url: 'https://example.com/eryinfang',
    description: '国内知名的ASMR资源聚合平台，汇集海量助眠音频、耳语视频和白噪音内容，每日更新优质ASMR作品，支持在线播放与下载，是你寻找asmr网站的首选入口。',
    category: 'zonghe-pingtai',
    tags: ['助眠', '耳语', '综合'],
    rating: 4.9,
    featured: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Calm%20warm%20minimalist%20ASMR%20studio%20scene%20with%20soft%20ambient%20lighting%2C%20gentle%20cream%20and%20beige%20tones%2C%20cozy%20atmosphere%20with%20headphones%20and%20soft%20textures%2C%20editorial%20photography%2C%20peaceful%20mood%2C%20clean%20composition&width=800&height=400&seq=resource-r1&orientation=landscape',
  },
  {
    id: 'r2',
    name: '静夜思助眠馆',
    url: 'https://example.com/jingyesi',
    description: '专注于失眠助眠的asmr助眠网站，提供高质量的雨声、海浪声、篝火声等自然白噪音，配合轻柔耳语引导，帮助数万用户告别失眠困扰。',
    category: 'zhumian-fangsong',
    tags: ['助眠', '白噪音', '失眠'],
    rating: 4.8,
    featured: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Moonlit%20peaceful%20bedroom%20scene%20with%20soft%20warm%20lighting%2C%20gentle%20cream%20and%20beige%20tones%2C%20cozy%20atmosphere%20for%20sleep%2C%20minimalist%20decor%2C%20editorial%20photography%2C%20calm%20mood&width=800&height=400&seq=resource-r2&orientation=landscape',
  },
  {
    id: 'r3',
    name: '白噪音森林',
    url: 'https://example.com/bznforest',
    description: '最全的asmr白噪音网站，提供超过200种高清自然音效，涵盖雨声、溪流、鸟鸣、风吹树叶等场景，支持混音自定义，打造专属放松空间。',
    category: 'bai-zaoyin',
    tags: ['白噪音', '自然音效', '混音'],
    rating: 4.7,
    featured: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Misty%20forest%20with%20soft%20morning%20light%2C%20gentle%20green%20and%20cream%20tones%2C%20peaceful%20natural%20atmosphere%2C%20minimalist%20nature%20photography%2C%20calm%20and%20serene%20mood&width=800&height=400&seq=resource-r3&orientation=landscape',
  },
  {
    id: 'r4',
    name: '轻声密语电台',
    url: 'https://example.com/qingsheng',
    description: '优质耳语ASMR创作平台，聚集了众多ASMR声优达人，提供中文耳语、轻声阅读、角色扮演等丰富内容，是asmr在线听的最佳选择之一。',
    category: 'eryu-asmr',
    tags: ['耳语', '轻声', '声优'],
    rating: 4.6,
    featured: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20recording%20studio%20with%20soft%20lighting%2C%20cream%20and%20beige%20interior%2C%20professional%20microphone%20on%20wooden%20desk%2C%20minimalist%20aesthetic%2C%20peaceful%20atmosphere&width=800&height=400&seq=resource-r4&orientation=landscape',
  },
  {
    id: 'r5',
    name: '沉浸式SPA音疗',
    url: 'https://example.com/spa-sound',
    description: '结合ASMR与音疗理念的专业放松平台，提供头部按摩、面部护理等角色扮演ASMR，配合3D环绕音效录制，带来极致的沉浸式体验。',
    category: 'jiaose-banyan',
    tags: ['角色扮演', '音疗', '3D音效'],
    rating: 4.8,
    featured: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20spa%20room%20with%20soft%20candles%20and%20warm%20lighting%2C%20cream%20and%20beige%20tones%2C%20peaceful%20atmosphere%20with%20white%20towels%20and%20aromatherapy%20oils%2C%20minimalist%20composition&width=800&height=400&seq=resource-r5&orientation=landscape',
  },
  {
    id: 'r6',
    name: '酥脆食音集',
    url: 'https://example.com/sucui',
    description: '专注于吃播ASMR与咀嚼音的资源平台，收录炸鸡、泡面、糖果、水果等多种食物的真实咀嚼声，满足你对听觉美食的所有想象。',
    category: 'chibo-jujueyin',
    tags: ['吃播', '咀嚼音', '美食'],
    rating: 4.5,
    featured: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20food%20photography%20with%20crispy%20textures%2C%20soft%20cream%20background%2C%20golden%20lighting%2C%20editorial%20style%20with%20subtle%20warm%20tones%2C%20clean%20composition&width=800&height=400&seq=resource-r6&orientation=landscape',
  },
  {
    id: 'r7',
    name: '触发音实验室',
    url: 'https://example.com/trigger-lab',
    description: '专业触发音ASMR创作社区，涵盖敲击、刮擦、翻页、键盘打字、瓶子碰撞等多种触发音类型，帮助用户快速进入放松状态。',
    category: 'chufa-yin',
    tags: ['触发音', '敲击', '刮擦'],
    rating: 4.6,
    featured: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20workspace%20with%20wooden%20desk%20and%20various%20textured%20objects%2C%20soft%20warm%20lighting%2C%20cream%20and%20beige%20tones%2C%20editorial%20photography%2C%20calm%20focused%20mood&width=800&height=400&seq=resource-r7&orientation=landscape',
  },
  {
    id: 'r8',
    name: '云端ASMR空间',
    url: 'https://example.com/cloud-asmr',
    description: '综合性ASMR在线听平台，覆盖助眠、白噪音、耳语、角色扮演等多种类型，界面简洁优雅，支持定时关闭和收藏功能，是最好的asmr网站之一。',
    category: 'zonghe-pingtai',
    tags: ['综合', '助眠', '在线听'],
    rating: 4.7,
    featured: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dreamy%20cloud%20and%20sky%20abstract%20minimalist%20background%2C%20soft%20cream%20and%20gentle%20warm%20tones%2C%20peaceful%20floating%20atmosphere%2C%20artistic%20composition%2C%20calm%20serene%20mood&width=800&height=400&seq=resource-r8&orientation=landscape',
  },
  {
    id: 'r9',
    name: '夜莺助眠电台',
    url: 'https://example.com/yeying',
    description: '24小时不间断的助眠ASMR直播平台，每晚有专业ASMR主播进行实时耳语和触发音表演，社区氛围温暖友好，是失眠患者的温馨港湾。',
    category: 'zhumian-fangsong',
    tags: ['助眠', '直播', '电台'],
    rating: 4.7,
    featured: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20night%20scene%20with%20soft%20lamp%20light%2C%20cream%20and%20beige%20bedroom%20interior%2C%20gentle%20nighttime%20atmosphere%2C%20peaceful%20sleep%20environment%2C%20minimalist%20decor&width=800&height=400&seq=resource-r9&orientation=landscape',
  },
  {
    id: 'r10',
    name: '深海白噪音馆',
    url: 'https://example.com/shenhai',
    description: '以海洋主题为核心的白噪音平台，提供深海水流、鲸鱼歌声、海浪拍岸等独特音效，帮助用户在城市的喧嚣中找到一片宁静的深海世界。',
    category: 'bai-zaoyin',
    tags: ['白噪音', '海洋', '深度放松'],
    rating: 4.5,
    featured: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20abstract%20minimalist%20scene%20with%20soft%20bluegreen%20gradients%2C%20gentle%20flowing%20water%20textures%2C%20peaceful%20underwater%20atmosphere%2C%20calm%20serene%20mood%2C%20artistic%20composition&width=800&height=400&seq=resource-r10&orientation=landscape',
  },
  {
    id: 'r11',
    name: '声之形ASMR',
    url: 'https://example.com/shengzhixing',
    description: '专注于视觉与听觉结合的ASMR网站，每个视频都经过精心拍摄和后期制作，画面唯美、声音细腻，为用户提供极致的感官享受。',
    category: 'chufa-yin',
    tags: ['触发音', '视觉ASMR', '高清'],
    rating: 4.8,
    featured: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20studio%20with%20soft%20natural%20lighting%2C%20cream%20and%20warm%20beige%20tones%2C%20artistic%20composition%20with%20gentle%20textures%2C%20editorial%20photography%2C%20peaceful%20creative%20space&width=800&height=400&seq=resource-r11&orientation=landscape',
  },
  {
    id: 'r12',
    name: '晚安呢喃馆',
    url: 'https://example.com/wannan',
    description: '温暖治愈的耳语ASMR频道，主播用最温柔的声线为你朗读睡前故事、诗歌和美文，配合舒缓的背景音乐，陪你进入甜美梦乡。',
    category: 'eryu-asmr',
    tags: ['耳语', '睡前故事', '治愈'],
    rating: 4.9,
    featured: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20warm%20evening%20lighting%2C%20cream%20and%20soft%20golden%20tones%2C%20comfortable%20armchair%20with%20blanket%2C%20peaceful%20storytime%20atmosphere%2C%20minimalist%20interior&width=800&height=400&seq=resource-r12&orientation=landscape',
  },
  {
    id: 'r13',
    name: '角色扮演剧场',
    url: 'https://example.com/rp-theater',
    description: '国内最大的角色扮演ASMR社区，从理发店、美容院到医生诊所、图书馆，各种场景应有尽有，专业的声优演绎让你身临其境。',
    category: 'jiaose-banyan',
    tags: ['角色扮演', '场景', '声优'],
    rating: 4.6,
    featured: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20theater%20stage%20with%20soft%20warm%20spotlight%2C%20cream%20and%20golden%20beige%20tones%2C%20artistic%20atmosphere%2C%20editorial%20photography%2C%20dramatic%20yet%20calm%20mood&width=800&height=400&seq=resource-r13&orientation=landscape',
  },
  {
    id: 'r14',
    name: '美食ASMR工坊',
    url: 'https://example.com/food-asmr',
    description: '专注美食吃播ASMR的优质频道，汇聚韩国炸鸡、日本拉面、中国火锅等各国美食的诱人咀嚼声，是asmr网站推荐中不可错过的美食频道。',
    category: 'chibo-jujueyin',
    tags: ['吃播', '美食', '国际'],
    rating: 4.4,
    featured: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20food%20preparation%20scene%20with%20soft%20lighting%2C%20cream%20and%20golden%20beige%20tones%2C%20artisan%20cooking%20atmosphere%2C%20editorial%20food%20photography%2C%20clean%20composition&width=800&height=400&seq=resource-r14&orientation=landscape',
  },
  {
    id: 'r15',
    name: '心灵SPA音疗室',
    url: 'https://example.com/spa-room',
    description: '融合ASMR与冥想音疗的综合平台，提供颂钵、水晶音叉、风铃等疗愈乐器的纯净声音，搭配专业冥想引导，帮助你深度释放压力。',
    category: 'zhumian-fangsong',
    tags: ['助眠', '音疗', '冥想'],
    rating: 4.8,
    featured: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Zen%20meditation%20space%20with%20soft%20natural%20lighting%2C%20cream%20and%20warm%20beige%20tones%2C%20singing%20bowl%20on%20wooden%20floor%2C%20peaceful%20mindfulness%20atmosphere%2C%20minimalist%20interior&width=800&height=400&seq=resource-r15&orientation=landscape',
  },
  {
    id: 'r16',
    name: '雨声ASMR小屋',
    url: 'https://example.com/rain-cabin',
    description: '专门收集世界各地雨声的asmr白噪音网站，从热带雨林的暴雨到江南小巷的细雨，数十种雨声场景任你选择，是最治愈的白噪音体验。',
    category: 'bai-zaoyin',
    tags: ['白噪音', '雨声', '治愈'],
    rating: 4.7,
    featured: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20cabin%20window%20with%20rain%20outside%2C%20warm%20interior%20lighting%2C%20cream%20and%20soft%20grey%20tones%2C%20peaceful%20rainy%20day%20atmosphere%2C%20minimalist%20composition%2C%20calm%20mood&width=800&height=400&seq=resource-r16&orientation=landscape',
  },
];